import { navigateToTab } from "@/route";
import { useCallback, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { type AlertNotification, fetchNotificationDestination } from "../api";

function profileIdFromPath(pathname: string) {
  const match = pathname.match(/\/workspace\/(\d+)(?:\/|$)/);
  return match ? Number(match[1]) : undefined;
}

export function useOpenNotification() {
  const { pathname } = useLocation();
  const profileId = profileIdFromPath(pathname);
  const request = useRef<AbortController>();
  useEffect(() => () => request.current?.abort(), [pathname]);
  return useCallback(
    async (item: AlertNotification) => {
      request.current?.abort();
      const controller = new AbortController();
      request.current = controller;
      try {
        const target = await fetchNotificationDestination(item.subscription_id, profileId, controller.signal);
        if (controller.signal.aborted) {
          return false;
        }
        navigateToTab(pathname, target.profile_id, target.tab_id);
        return true;
      } catch (error) {
        if (controller.signal.aborted) {
          return false;
        }
        throw error;
      }
    },
    [pathname, profileId],
  );
}
